import { EActionTypes } from './types';
import { TSetAppBarTitle, TSetAppBarReset } from './actions.types';

export const setAppBarTitle: TSetAppBarTitle = (title) => ({
    type: EActionTypes.SET_TITLE,
    payload: {
        title,
    },
});

export const setAppBarReset: TSetAppBarReset = () => ({
    type: EActionTypes.APP_BAR_RESET,
});
